<script setup>
import {ref, reactive, onMounted, inject, onBeforeUnmount, watch, nextTick, useTemplateRef, computed} from 'vue';
    import { onBeforeRouteLeave } from 'vue-router';
    import { useStore } from 'vuex';

    const notify = inject('notify');

    const isActive = ref(false)

    const props = defineProps({
        name: String,
        header: String,
        text: {
            type: String,
            required: true,
            default: '',
        },
        link: {
            type: String,
            required: false,
            default: ''
        },
        color: String
    });

    const content = useTemplateRef('content')

    const getContentHeight = computed(() => {
        if (isActive.value) {
            return content.value.querySelector('p').getBoundingClientRect().height + 'px';
        } else { return '0' }
    })

    const setActive = () => {
        if (!props.link) {
            isActive.value = !isActive.value;
        }
    }

</script>

<template>
    <div v-if="!link" :class="['acc-item', name ? name : '']" @click="setActive" :style="`background: ${color ? color : ''}`">
        <div class="acc-header">
            <div class="head">
                <svg class="doc-icn" width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.667 3.33301V12.9307H0V0H7.33301L10.667 3.33301ZM1.28027 11.6025H9.33301V3.88672L6.78027 1.33301H1.28027V11.6025Z" fill="black"/>
                </svg>
                <p>{{ header }}</p>
            </div>
            <svg :class="['more-icn', isActive ? 'active' : '']" @click.stop.prevent="setActive" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path @click.stop.prevent="setActive" fill-rule="evenodd" clip-rule="evenodd" d="M5.17305 5.66277L0.728516 1.21824L1.83945 0.107299L5.72852 3.99636L9.61758 0.1073L10.7285 1.21824L6.28398 5.66277C6.13665 5.81006 5.93685 5.8928 5.72852 5.8928C5.52018 5.8928 5.32038 5.81006 5.17305 5.66277Z" fill="#1C1C1C"/>
            </svg>
        </div>
        <div class="acc-content" ref="content" v-if="text" :class="[isActive ? 'active' : '']" :style="`height: ${getContentHeight}`" v-html="text">
        </div>
    </div>
    <a v-else :href="link" target="_blank" class="acc-item" :style="`background: ${color ? color : ''}`">
        <div class="acc-header">
            <div class="head">
                <svg class="doc-icn" width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.667 3.33301V12.9307H0V0H7.33301L10.667 3.33301ZM1.28027 11.6025H9.33301V3.88672L6.78027 1.33301H1.28027V11.6025Z" fill="black"/>
                </svg>
                <p>{{ header }}</p>
            </div>
            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.59099 0.750026H7.95495V7.11399M7.51301 1.19197L1.06066 7.64432" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
            </svg>
        </div>
    </a>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;
    .acc-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 12px 17px;
        background: $silver;
        border-radius: 10px;
        box-sizing: border-box;
        transition: $transition;
        cursor: pointer;
    }

    .acc-item:hover {
        background: $silver-hover;
        //box-shadow: $shadow;
    }

    .acc-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .acc-header .head {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
    }

    .acc-item p, .acc-item a {
        line-height: normal;
        font-size: 14px;
        text-decoration: none;
    }

    .acc-content {
        height: 0;
        transition: $transition;
    }

    .acc-content.active {
        height: max-content;
        margin-top: 10px;
    }

    .acc-content > * {
        visibility: hidden;
        transition: $transition;
    }

    .acc-content.active > * {
        visibility: visible;
    }

    .more-icn {
        transform: rotate(0);
        transition: $transition;
    }

    .more-icn.active {
        transform: rotate(-180deg);
    }

    .doc-icn {
        padding-bottom: 2px
    }

    .acc-content > * {
        font-size: 14px;
    }

    .acc-content > * > * {
        text-decoration: underline;
        color: $hard-gray;
        transition: $transition;
    }

    .acc-content > * > *:hover {
        color: $black;
    }

    @media screen and (max-width: 750px) {
        .acc-item {
            padding: 9px 13px;
        }

        .acc-item p, .acc-item a {
            font-size: 13px;
        }

        .acc-content > * {
            font-size: 13px;
        }
    }
</style>